module.exports = __webpack_public_path__ + "img/styles.cac6e392.png";